export default __webpack_public_path__ + "static/media/addLanguageCircle.70840f6b.svg";